import store from '../../store/store'
import locale from '@packs/locale/locale'

import('./legend.scss')

export default function Legend(){
    let main_container
    let legend_plu_wrapper, legend_flu_wrapper, legend_landslide_wrapper

    let current_state = {plu:true, flu:false, landslide:false}

    let legends = {
        plu:[
            {title: "< 10 mm", class:"low", id:'low'},
            {title: "10 <> 30 mm", class:"moderate", id:'moderate'},
            {title: "30 <> 70 mm", class:"high", id:'high'},
            {title: "> 70 mm", class:"very-high", id:'very-high'},
        ],
        flu:[
            {title: "ok", class:"ok", id:'ok', type:'flu'},
            {title: "attention", class:"attention", id:'attention', type:'flu'},
            {title: "alert", class:"alertt", id:'alert', type:'flu'},
            {title: "emergency", class:"emergency", id:'emergency', type:'flu'},
            {title: "extravasation", class:"extravasation", id:'extravasation', type:'flu'},
        ],
        landslide:[
            {title: "no data", class:"default", id:'no_data', type:'landslide'},
            {title: "ok", class:"ok", id:'ok', type:'landslide'},
            {title: "attention", class:"attention", id:'attention', type:'landslide'},
        ]
    }

    this.generate = () =>{
        legend_plu_wrapper = document.createElement('div')
        legend_flu_wrapper = document.createElement('div')
        legend_landslide_wrapper = document.createElement('div')

        $(legend_plu_wrapper).addClass('legend-container')
        $(legend_flu_wrapper).addClass('legend-container')
        $(legend_landslide_wrapper).addClass('legend-container')

        generateLegendsPlu()
        generateLegendsFlu()
        generateLegendsLandSlide()

        store.mainConfigStore.subscribe('TYPE_UPDATE', data =>{
            handleDisplayLegends()
        })
        store.landslideConfigStore.subscribe('SET_OPTION', data =>{
            handleDisplayLegends()
        })

        $(document).find('body').append(legend_plu_wrapper,legend_flu_wrapper,legend_landslide_wrapper)

    }

    const handleDisplayLegends = () =>{
        current_state.flu = false
        current_state.plu = false
        current_state.landslide = false

        let landSlide = store.landslideConfigStore.getOption('active')
        let current = store.mainConfigStore.getType()

        if(current === 'plu' && landSlide){
            current_state.landslide = true
            current_state.flu = false
            current_state.plu = false
        } else if(current === 'plu'){
            current_state.plu = true
        } else {
            current_state.flu = true
        }
        
        $(legend_plu_wrapper).css('display', current_state['plu'] ? 'flex' : 'none')
        $(legend_flu_wrapper).css('display', current_state['flu'] ? 'flex' : 'none')
        $(legend_landslide_wrapper).css('display', current_state['landslide'] ? 'flex' : 'none')
    }

    const generateLegendsLandSlide = _ =>{
        $.each(legends.landslide, (index, legend)=>{
            let legend_item = new LegendItem({legend: legend, type: 'landslide'})
            legend_item.generate()
            $(legend_landslide_wrapper).append(legend_item.getElement())
        })
    }

    function generateLegendsFlu(){
        $.each(legends.flu, (index, legend)=>{
            let legend_item = new LegendItem({legend: legend, type: 'flu'})
            legend_item.generate()
            $(legend_flu_wrapper).append(legend_item.getElement())
        })
    }

    function generateLegendsPlu(){
        $.each(legends.plu, (index, legend)=>{
            let legend_item = new LegendItem({legend: legend, type: 'plu'})
            legend_item.generate()
            $(legend_plu_wrapper).append(legend_item.getElement())
        })
    }

    function LegendItem(options){
        let element = document.createElement('div')
        let square = document.createElement('div')
        let overlay = document.createElement('div')
        let legend = options.legend
        let type = options.type
        let state = true
        this.generate = () =>{
            $(element).addClass('legend-item')
            $(overlay).addClass('legend-item-overlay')
            $(square).addClass('legend-item-square '+legend.class)

            $(square).html((type === 'flu' || type === 'landslide') ? locale.t(legend.title) : legend.title)

            $(element).append(square)
            $(element).append(overlay)

            element.onclick = function(){
                state = !state
                $(square).toggleClass(legend.class, state)
                if(type === 'flu'){
                    store.fluConfig.setFilterLegendsOption(legend.id, state)
                } else if(type === 'plu') {
                    store.fluConfig.setFilterPluLegendsOption(legend.id, state)
                } else {
                    store.landslideConfigStore.setFilterOption('legends',{...store.landslideConfigStore.getFilterOption('legends'), [legend.id]:state})
                }
                
            }
        }
        this.getElement = () =>{
            return element
        }
    }
}